window.DOC_ISSUING_AUTH = {
    US_DEPARTMENT : {
        issuing_authority_type: 'US_DEPART_STATE',
        issuings: [{
            Code: "US_DEPART_STATE",
            Name: "U.S. Department of State"
        }],
        docs:["US_PASSPORT", "FORM_FS_545", "US_PASSPORT_CARD", "FORM_DS_1350", "FORM_DS_2019", "CONSULAR_REPORT_OF_BIRTH_ABROAD"]
    },
    N_A : {
        issuing_authority_type: "NO_ISSUING_AUTH",
        issuings: 'NO_ISSUING_AUTH',
        docs:["SPECIAL_PLACEMENT"]
    },
    FEDERAL_STATES : {
        issuing_authority_type: "COUNTRY",
        issuings: [{
            Code: "FSM",
            Name: "Federated States of Micronesia"
        }],
        docs:["RECEIPT_FSM_PASSPORT", "FSM_PASSPORT"]
    },
    STATES_OF_US : {
        issuing_authority_type: "STATE",
        issuings: US_STATES.map(function (state) {
            return {
                Code: state.abbreviation,
                Name: state.name
            };
        }),
        docs:["DRIVER_LICENSE", "RECEIPT_DRIVER_LICENSE", "ID_CARD_BY_STATE", "RECEIPT_ID_CARD_BY_STATE"]
    },
    FREE_TEXT : {
        issuing_authority_type: "FREE_TEXT",
        issuings: 'FREE_TEXT',
        docs:["GOVERMENT_ID", "SCHOOL_ID", "VOTER_REG_CARD", "US_MILITARY_CARD",
            "US_MILITARY_DRAFT", "MILITARY_DEP_ID", "RECEIPT_GOVERMENT_ID",
            "RECEIPT_SCHOOL_ID", "RECEIPT_VOTER_REG_CARD", "RECEIPT_US_MILITARY_DRAFT",
            "RECEIPT_MILITARY_DEP_ID", "RECEIPT_USCG_MERCH_MARINER_CARD",
            "NATIVE_AMERICAN_TRIPLE_DOC", "RECEIPT_REPLACEMENT_BIRTH_CERTIFICATE",
            "RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL", "US_BRITH_CERTIFICATE",
            "SCHOOL_RECORD_UND_18", "REPORT_CARD_UND_18", "CLINIC_RECORD_UND_18",
            "DOCTOR_RECORD_UND_18", "HOSPITAL_RECORD_UND_18", "DAY_CARE_RECORD_UND_18",
            "NURSERY_SCHOOL_RECORD_UND_18"]
    },
    SOCIAL_SECURITY : {
        issuing_authority_type: "SSA",
        issuings: [{
            Code: "SSA",
            Name: "Social Security Administration"
        }],
        docs:["RECEIPT_REPLACEMENT_UNRESTRICTED_SS_CARD"]
    },
    DOJ : {
        issuing_authority_type: "DOJ_IMMIGRATION",
        issuings: [{
            Name: "DOJ Immigration and Naturalization Service",
            Code: "DOJ_IMMIGRATION"
        }],
        docs:["FORM_I_197", "FORM_I_179", "ALIEN_PERM_RESID_CARD"]
    },
    DHS : {
        issuing_authority_type: "DHS",
        issuings: [{
            Name: "DHS",
            Code: "DHS"
        }],
        docs:["EMPLOYMENT_AUTH_DHS", "RECEIPT_REPLACEMENT_EMPLOYMENT_AUTH_DHS"]
    },
    COAST_GUARD : {
        issuing_authority_type: "US_COAST_GUARD",
        issuings: [{
            Name: "U.S. Coast Guard",
            Code: "US_COAST_GUARD"
        }],
        docs:["USCG_MERCH_MARINER_CARD", "RECEIPT_NATIVE_AMERICAN_TRIPLE_DOC"]
    },
    CANADA : {
        issuing_authority_type: "CANADA",
        issuings: [{
            Name: "Alberta",
            Code: "AB"
        },{
            Name: "British Columbia",
            Code: "BC"
        },{
            Name: "Monitoba",
            Code: "MB"
        },{
            Name: "New Brunswick",
            Code: "NB"
        },{
            Name: "Newfoundland and Labrador",
            Code: "NL"
        },{
            Name: "Nova Scotia",
            Code: "NT"
        },{
            Name: "Ontario",
            Code: "ON"
        },{
            Name: "Prince Edward Island",
            Code: "PE"
        },{
            Name: "Quebec",
            Code: "QC"
        },{
            Name: "Saskatchewan",
            Code: "SK"
        },{
            Name: "Northwest Territories",
            Code: "NT"
        },{
            Name: "Nunavut",
            Code: "NU"
        },{
            Name: "Yukon",
            Code: "YT"
        }],
        docs:["CANADIAN_DRIVER_LICENSE", "RECEIPT_CANADIAN_DRIVER_LICENSE", "RECEIPT_SPECIAL_PLACEMENT"]
    },
    HOME_LAND_SECURITY : {
        issuing_authority_type: "HOME_LAND_SECURITY",
        issuings: [{
            Code: "HOME_LAND_SECURITY",
            Name: "U.S. Department of Homeland Security"
        }],
        docs:["RECEIPT_I_94", "RECEIPT_I_94_REFUGEE"]
    },
    SOCIAL_SECURITY_ORGS : {
        issuing_authority_type: "SOCIAL_SECURITY_ORGS",
        issuings: [{
            Code: "SSA",
            Name: "Social Security Administration"
        },{
            Code: "US_DHHS",
            Name: "U.S. Department of Health and Human Services"
        },{
            Code: "SSB",
            Name: "Social Security Board"
        },{
            Code: "DHEW",
            Name: "Department of Health, Education and Welfare"
        }],
        docs:["SOCIAL_SECURITY_CARD_UNRESTRICTED"]
    },
    DOJ_US : {
        issuing_authority_type: "DOJ_US",
        issuings: [{
            Code: "USCIS",
            Name: "U.S. Citizenship and Immigration Service"
        }, {
            Code: "DOJINS",
            Name: "DOJ Immigration and Naturalization Service"
        }],
        docs:["TEMP_I_551_STAMP", "PERM_RESID_CARD"]
    },
    US_IMM : {
        issuing_authority_type: "US_IMM",
        issuings: [{
            Code: "USCIS",
            Name: "U.S. Citizenship and Immigration Service"
        }],
        docs:["MACHINE_READABLE_IMMIGRANT_VISA", "EMP_AUTH_DOC", "RECEIPT_PERM_RESID_CARD", "RECEIPT_REPLACEMENT_EAD"]
    },
    CITIZEN_CUSTOM : {
        issuing_authority_type: "US_IMM",
        issuings: [{
            Code: "USCIS",
            Name: "U.S. Citizenship and Immigration Services"
        }, {
            Code: "USCBP",
            Name: "U.S. Custom and Border Protection"
        }],
        docs:["FORM_I_94_A", "RECEIPT_FORM_I_94_A"]
    },
    IMM_DOJ : {
        issuing_authority_type: "IMM_DOJ",
        issuings: [{
            Code: "USICE",
            Name: "U.S. Immigration and Customs Enforcement"
        }, {
            Code: "US_DOJ_INS",
            Name: "US DOJ INS"
        }],
        docs:["FORM_I_20"]
    },
    REPUBLIC_ISLAND : {
        issuing_authority_type: "COUNTRY",
        issuings: [{
            Code: "MHL",
            Name: "Republic of the Marshall Islands"
        }],
        docs:["RIM_PASSPORT", "RECEIPT_RIM_PASSPORT"]
    },
    COUNTRIES : {
        issuing_authority_type: "COUNTRY",
        issuings: countries.map(function (country) {
            return {
                Code: country.Code,
                Name: country.Description
            }
        }),
        docs:["FOREIGN_PASSPORT_TEMP_MRIV", "FOREIGN_PASSPORT_TEMP_STAMP", "FOREIGN_PASSPORT", "RECEIPT_FOREIGN_PASSPORT"]
    }
};
